import React from 'react';

import { CircleButton, LinkButton } from 'ui/component';
import classNames from './EABD2CaseFooter.module.scss';

export interface CaseFooterProps
  extends Readonly<{
    isLastTab: boolean;
    isLastCase: boolean;
    onBackButtonPress: () => void;
    onNextButtonPress: () => void;
    onNextCaseButtonPress: () => void;
  }> {}

export const CaseFooter = React.memo<CaseFooterProps>((props) => {
  const { isLastTab, isLastCase, onBackButtonPress, onNextButtonPress, onNextCaseButtonPress } = props;

  const LeftElement = React.useMemo<JSX.Element>(() => {
    return (
      <LinkButton
        text={'back'}
        arrowPosition={'before'}
        arrowDirection={'left'}
        color={'onBackgroundLighter'}
        shouldUseSmallerFontSize={true}
        shouldFadeIn={true}
        onPress={onBackButtonPress}
      />
    );
  }, [onBackButtonPress]);

  const RightElement = React.useMemo<JSX.Element>(() => {
    if (isLastTab) {
      return isLastCase ? (
        <div />
      ) : (
        <CircleButton
          text={'next usecase'}
          circlePosition={'after'}
          arrowDirection={'right'}
          shouldFadeIn={true}
          onPress={onNextCaseButtonPress}
        />
      );
    }

    return (
      <LinkButton
        text={'next'}
        arrowPosition={'after'}
        arrowDirection={'right'}
        color={'onBackgroundLighter'}
        shouldUseSmallerFontSize={true}
        shouldFadeIn={true}
        onPress={onNextButtonPress}
      />
    );
  }, [isLastTab, isLastCase, onNextButtonPress, onNextCaseButtonPress]);

  return (
    <div className={classNames.root}>
      {LeftElement}
      {RightElement}
    </div>
  );
});
